import {Component, input, effect, computed} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {AResourceTableComponent} from "../../../../AResourceTableComponent";
import {FormBuilder} from "@angular/forms";
import {HttpErrorsService} from "../../../../../services/utils/http-errors.service";
import {CustomNotificationService} from "../../../../../services/utils/custom-notification.service";
import {OptimizationRunStopModel} from "../../../../../models/resources/optimization-run-stop.model";
import {OptimizationRunStopService} from "../../../../../services/resources/optimization-run-stop.service";
import {TableColumnModel} from "../../../../../models/table-column.model";
import {castStopTypeEnum} from "../../../../../enums/stop-type";
import {TableComponent} from "../../../../utils/table/table.component";

@Component({
  selector: 'app-optimization-run-stops-table',
  imports: [ TranslateModule, TableComponent ],
  template: `
      @for (group of groupedStops(); track group[0].busId) {
        <h5 class="fw-bold">Bus {{ group[0].busId }}</h5>
            <app-table
              [columns]="tableColumns"
              [data]="group"
              [loading]="resourceService.loading()"
              (doFilterRequest)="resourceService.getAll($event)"
              (urlParamsChange)="this.urlParams = $event"
              [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
              [deleteLoadingIds]="this.deleteLoadingIds()"
            />
<br>
  } @empty {
      <p class="text-muted">{{"OPTIMIZATION_RUN_STOPS.NO_STOPS_FOUND" | translate}}</p>
    }`
})
export class OptimizationRunStopsTableComponent extends AResourceTableComponent<OptimizationRunStopModel> {
  optimizationRunId = input.required<number>();

  tableColumns: TableColumnModel[]= [
    {
      name: 'OPTIMIZATION_RUN_STOPS.STOP_ORDER',
      selector: [{ selector: 'orderId' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.STOP_TYPE',
      selector: [{ selector: 'stopType.label'}]
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.START_ADDRESS',
      selector: [{ selector: 'startAddress' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.DESTINATION_ADDRESS',
      selector: [{ selector: 'destinationAddress' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.VEHICLE',
      selector: [{ selector: 'vehicle.name' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.EMPLOYEE',
      selector: [{ selector: 'vitabeneEmployee.firstName', suffix: ' ' },
        { selector: 'vitabeneEmployee.lastName' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.VITABENE_STOP_ID',
      selector: [{ selector: 'vitabeneStopId' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.ARRIVAL_TIME',
      selector: [{ selector: 'arrivalTime' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.STOP_DURATION',
      selector: [{ selector: 'stopDuration' }],
    },
    {
      name: 'OPTIMIZATION_RUN_STOPS.ADDITIONAL_INFO',
      selector: [{ selector: 'additionalInfo' }],
    },
  ];

  constructor(
    formBuilder: FormBuilder,
    public optimizationRunStopService: OptimizationRunStopService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      optimizationRunStopService,
      httpErrorsService,
      notificationService,
      'OPTIMIZATION_RUN_STOPS');

    effect(() => {
      if(!this.optimizationRunId()) return;

      this.optimizationRunStopService.setOptimizationRunId(this.optimizationRunId());
    });
  }

  groupedStops = computed(() =>
    Object.values(
      this.models().reduce((acc, stop) => {
        const key = stop.busId ?? 'x';
        (acc[key] ??= []).push(stop);
        return acc;
      }, {} as Record<string, OptimizationRunStopModel[]>)
    )
  );

  override ngOnInit() {
    const optimizationRunId = this.optimizationRunId();

    if (!optimizationRunId) return;

    this.resourceService.getAll({
      resetData: true,
    });
  }

  protected readonly castStopTypeEnum = castStopTypeEnum;
}
